<div *ngIf="overrides.length" class="flex flex-col gap-3 border rounded-xl px-4 py-3">
  <div class="flex flex-col">
    <p class="text-sm font-semibold text-gray-900">Approvals</p>
    <p class="text-xs text-gray-500">The tenant's rules hold these back until a manager approves them.</p>
  </div>

  <div class="flex flex-col divide-y">
    <div *ngFor="let override of overrides" class="flex flex-wrap items-center justify-between gap-3 py-2 text-sm">
      <div class="flex flex-col min-w-0">
        <div class="flex items-center gap-2">
          <p class="text-gray-900">{{ describe(override) }}</p>
          <vs-badge [theme]="badge(override).theme">{{ badge(override).text }}</vs-badge>
        </div>
        <p *ngIf="override.decided" class="text-xs text-gray-500">
          {{ override.decidedBy?.displayName || override.decidedBy?.email || 'A manager' }} ·
          {{ override.decided | date: 'medium'
          }}<ng-container *ngIf="override.reason"> · "{{ override.reason }}"</ng-container>
        </p>
        <p *ngIf="nextStep(override) as step" class="text-xs font-medium text-warn-700">{{ step }}</p>
      </div>

      <div *ngIf="canManage" class="flex items-center gap-2 shrink-0">
        <ng-container *ngIf="override.state === State.PENDING">
          <button
            vs-button
            appearance="outline"
            size="sm"
            [disabled]="saving"
            (click)="decide(override, Action.REJECT)"
          >
            Reject
          </button>
          <button vs-button theme="primary" size="sm" [disabled]="saving" (click)="decide(override, Action.APPROVE)">
            Approve
          </button>
        </ng-container>
        <button
          *ngIf="override.state === State.APPROVED && !paidTargetIds.includes(override.targetId)"
          vs-button
          appearance="outline"
          size="sm"
          [disabled]="saving"
          (click)="decide(override, Action.REVERSE)"
        >
          Reverse
        </button>
      </div>
    </div>
  </div>
</div>

<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[480px] max-w-[90%]' }">
  <vs-dialog-header
    class="self-start w-full"
    [config]="{
      mode: 'simple',
      icon: deciding?.action === Action.REVERSE ? 'reverse-left' : 'x-circle',
      iconTheme: 'danger',
      title: deciding?.action === Action.REVERSE ? 'Reverse Approval' : 'Reject',
      subtitle: deciding ? describe(deciding.override) : '',
      showDivider: true,
    }"
  ></vs-dialog-header>

  <div class="flex flex-col gap-4 w-full mt-4">
    <vs-form-field [config]="{ label: 'Reason' }">
      <textarea
        vsInput
        minRows="2"
        maxRows="4"
        [formControl]="reason"
        placeholder="e.g. Needs a second quote"
      ></textarea>
    </vs-form-field>

    <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">
      <button
        vs-button
        type="button"
        appearance="outline"
        class="w-full sm:w-auto"
        [disabled]="saving"
        (click)="close()"
      >
        Cancel
      </button>
      <button
        vs-button
        type="button"
        theme="danger"
        class="w-full sm:w-auto"
        [disabled]="saving || reason.invalid"
        (click)="confirm()"
      >
        {{ deciding?.action === Action.REVERSE ? 'Reverse' : 'Reject' }}
      </button>
    </div>
  </div>
</vs-dialog>
